import React, { useCallback } from 'react';
import { InputField } from '../../input/InputField';
import { BackIcon } from '../../svg/BackIcon';
import * as Yup from 'yup';
import { useFormWithSchema } from '../../../client/hooks/use-form-schema';
import { gql } from 'urql';
import { useAuthenticatedMutation } from '../../../client/hooks';
import {
    CreatePlayerReferralCodeRedemptionMutation,
    CreatePlayerReferralCodeRedemptionMutationVariables,
    CreatePlayerReferralCodeRedemptionDocument,
    RedeemPlayerReferralCodeInsertInput,
} from 'generated/spin-graphql';
import { useAppState } from '../../../client/providers/AppProvider';
import { toast } from 'react-toastify';

type Props = {};

const FormDataSchema = Yup.object({
    referral_code: Yup.string().required(),
});
export type ReferralCodeRedemptionFormDataSchema = Yup.InferType<typeof FormDataSchema>;

gql`
    mutation CreatePlayerReferralCodeRedemption($input: RedeemPlayerReferralCodeInsertInput!) {
        redeemPlayerReferralCode(input: $input) {
            codeId
        }
    }
`;

export const PlayerReferralCode: React.FC<Props> = () => {
    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { isSubmitting, isDirty, errors },
    } = useFormWithSchema(FormDataSchema);

    const { user, reloadUser } = useAppState();

    const [_, createReferralCodeRedemption] = useAuthenticatedMutation<
        CreatePlayerReferralCodeRedemptionMutation,
        CreatePlayerReferralCodeRedemptionMutationVariables
    >(CreatePlayerReferralCodeRedemptionDocument);

    const onSubmit = useCallback(
        async (values: ReferralCodeRedemptionFormDataSchema) => {
            const input: RedeemPlayerReferralCodeInsertInput = {
                codeKey: values.referral_code,
                playerId: user?.player_profile?.id,
            };
            const result = await createReferralCodeRedemption(
                { input },
                { additionalTypenames: ['espin_referral_code_redemption'] },
            );
            if (result.error) {
                toast.error(`Invalid referral code entered`);
                console.error(result.error);
                return;
            }
            toast.success('Referral code successfully redeemed');
            reloadUser();
        },
        [createReferralCodeRedemption, user?.player_profile?.id, reloadUser],
    );

    return (
        <div className="referral-code-container">
            <form
                className="referral-code-form"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(onSubmit)(e);
                }}
            >
                <InputField
                    error={errors.referral_code?.message}
                    htmlFor={'referral_code'}
                    label="Referral Code"
                    placeholder="Referral Code"
                    required={true}
                    register={register}
                />
                <button type="submit" className="button blue-button referral-button">
                    <BackIcon />
                </button>
            </form>
        </div>
    );
};
